var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContextMenuIcon = function SvgContextMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 8.33398C4.25389 8.33398 5.00008 9.08018 5.00008 10.0007C5.00008 10.9211 4.25389 11.6673 3.33341 11.6673C2.41294 11.6673 1.66675 10.9211 1.66675 10.0007C1.66675 9.08018 2.41294 8.33398 3.33341 8.33398ZM16.6667 8.33398C17.5872 8.33398 18.3334 9.08018 18.3334 10.0007C18.3334 10.9211 17.5872 11.6673 16.6667 11.6673C15.7463 11.6673 15.0001 10.9211 15.0001 10.0007C15.0001 9.08018 15.7463 8.33398 16.6667 8.33398ZM10.0001 8.33398C10.9206 8.33398 11.6667 9.08018 11.6667 10.0007C11.6667 10.9211 10.9206 11.6673 10.0001 11.6673C9.07961 11.6673 8.33342 10.9211 8.33342 10.0007C8.33342 9.08018 9.07961 8.33398 10.0001 8.33398Z",
    fill: "white"
  }))));
};
export { SvgContextMenuIcon as ReactComponent };
export default __webpack_public_path__ + "assets/34f8e176.svg";